enum MealPlanTemplate {MY, LIBRARY, GROUPS};
export {MealPlanTemplate};
